import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export default Container;
